const custom_profile_fields = {
    /** UNTRANSLATED */
    entity_not_exists_with_names: 'Cannot find entities with the given names: {{names}}',
    invalid_min_max_input: 'Entrada de mínimo y máximo no válida.',
    invalid_options: 'Opciones de campo no válidas.',
    invalid_regex_format: 'Formato de expresión regular no válido.',
    invalid_address_parts: 'Partes de dirección no válidas.',
    invalid_fullname_parts: 'Partes de nombre completo no válidas.',
    name_exists: 'Ya existe un campo con el nombre proporcionado.',
    conflicted_sie_order: 'Valor de orden de campo en conflicto para la experiencia de inicio de sesión.',
    /** UNTRANSLATED */
    invalid_name: 'Invalid field name, only letters or numbers are allowed, case sensitive.',
};
export default Object.freeze(custom_profile_fields);
